import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { safeResolve } from 'src/app/shared/modules/graphql/rxjs';
import { getInvestigationMetricsBasicQuery } from "./investigation-metrics-basic.operations";
import { IApiInvestigationMetricsBasicConnection, IApiInvestigationMetricsFilter } from 'src/app/shared/modules/graphql/types/types';
import { IGqlBaseOptions } from "../../../../interfaces";
import { connectionQuery } from "../../../../helpers.class";

@Injectable()
export class GqlInvestigationMetricsBasicService {
  public constructor(
    private apollo: Apollo
  ) { }

  public get(filters: IApiInvestigationMetricsFilter[], options: IGqlBaseOptions): Observable<IApiInvestigationMetricsBasicConnection> {
    return this.apollo.query(connectionQuery(getInvestigationMetricsBasicQuery, filters, options)).pipe(
      safeResolve(true)
    );
  }

}
